import { Component, OnInit, ViewChild } from '@angular/core';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FilterpopupComponent } from '../grid/filterpopup/filterpopup.component';
import moment from 'moment';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';

@Component({
  selector: 'app-approvals',
  templateUrl: './approvals.component.html',
  styleUrls: ['./approvals.component.css']
})
export class ApprovalsComponent implements OnInit {

  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;

  formname: string = "Approvals";

  filterstatus: string = "";
  dtOptions: DataTables.Settings = {};

  formColl: any = [];
  statusColl: any = [];
  approvalsColl: any = [];

  approvalform: string = "";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterbranchid: any = null;
  filterbranchname: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;



 
  searchtxt: any = "";
  
  columnDefs = [
    { headerName: 'Form', field: 'trxtype' },
    { headerName: 'Employee', field: 'empname' },
    {
        headerName: 'Date', field: 'transdt', type:'date'    
    },
    { headerName: 'Remarks', field: 'typename' },
    { headerName: 'Desc', field: 'descr' },
    { headerName: 'Status', field: 'approvedstatus' },
  ]
  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
  };

  constructor(private appService: AppdataService, private loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, private datePipe: DatePipe) {
      this.fnGetParameterVariable();
    this.fnServiceChanges();
  }

  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
     
      if (params.status !== undefined) {
        this.filterstatus = params.status
      }
      if (params.empid !== undefined) {
          this.filteremployeeid = params.empid
        }
        if (params.empname !== undefined) {
          this.filteremployeename = params.empname
        } 
        if (params.branchid !== undefined) {
          this.filterbranchid = params.branchid
        }
        if (params.branchname !== undefined) {
          this.filterbranchname = params.branchname
        } 
      if (params.fromdate !== undefined) {         
        this.filterfromdate =  this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {        
        this.filtertodate=  this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
    })
  }


  //Company Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fngetApprovalsListview();
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  //Init
  ngOnInit() {
    try {
      this.fnGetForms();


      if (this.loginService.fnCheckCompany()) {
        this.fngetApprovalsListview();
      }



    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnGetForms() {
    this.formColl = [];
    this.formColl.push({ name: '', displayname: 'All Forms' });
    this.formColl.push({ name: 'BONUS', displayname: 'Bonus' });
    this.formColl.push({ name: 'PAYADJUSTMENT', displayname: 'PayAdjustment' });
    this.formColl.push({ name: 'FINE', displayname: 'Fine' });
    this.formColl.push({ name: 'EMPDETAILSCHANGES', displayname: 'EmpolyeeChanges' });
    this.formColl.push({ name: 'SHORTTERMPAY', displayname: 'ShortTermPay' });

    this.formColl.push({ name: 'LOAN', displayname: 'Loan' });
    this.formColl.push({ name: 'PAYADVANCE', displayname: 'PayAdvance' });
    this.formColl.push({ name: 'REIMBURSE', displayname: 'Reimburse' });
    this.formColl.push({ name: 'TRANSFER', displayname: 'Transfer' });
    this.formColl.push({ name: 'OTHERREQUEST', displayname: 'OtherRequest' });
    this.formColl.push({ name: 'LEAVE', displayname: 'Leave' });
    this.formColl.push({ name: 'OVERTIME', displayname: 'OverTime' });
  }


  

  //Event  
  fnActionEditClick(data) {
  
      this.fnEditForm(data.trxid, data.trxtype);
    }
 

  fnActionFilterClick() {

    // this.filterbar.filterstatus = this.filterstatus;
 
     //this.isfilter = !this.isfilter;
     this.fnShowFilterPopup();
  }


  fnApplyFilterPop(data) {
    //this.isfilter = !this.isfilter;
    this.filteremployeeid = data.empid;
    this.filteremployeename = data.empname;
    this.filterbranchid = data.branchid;
    this.filterbranchname = data.branchname;
    this.filterfromdate = data.fromdate;
    this.filtertodate = data.todate;
    this.filterstatus=data.status

    this.fngetApprovalsListview();
     
  }

  fnApplyFilter(data) {
    //this.isfilter = !this.isfilter;

    this.filterstatus = data;

    this.fngetApprovalsListview();

  }
  
  fnCurrentRouteChange() {
    var queryParams = {};


    if (this.filterstatus != '') {
      queryParams['status'] = this.filterstatus;
    }
    if (this.filteremployeeid > 0) {
      queryParams['empid'] = this.filteremployeeid;
    }
    if (this.filteremployeename !='') {
      queryParams['empname'] = this.filteremployeename;
    }
    if (this.filterfromdate !='') {
      queryParams['fromdate'] = this.fnFormatDatetime(this.filterfromdate);
    }
    if (this.filtertodate !='') {
      queryParams['todate'] = this.fnFormatDatetime(this.filtertodate);
    }
    if (this.filterbranchid > 0) {
      queryParams['branchid'] = this.filterbranchid;
    }
    if (this.filterbranchname !='') {
      queryParams['branchname'] = this.filterbranchname;
    }
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,

      });
  }
  

  fnRemoveFilter(type) {

    if (type === 'INACTIVE') {
      this.filterstatus = "";
      this.fngetApprovalsListview();
    }
    else {
      this.filterstatus = "";
      this.fngetApprovalsListview();
    }
  }

  //Get
  fngetApprovalsListview() {
    var data = {
      'formname': this.approvalform,
      'status': this.filterstatus,
      'empid': this.filteremployeeid, 
      'branchid': this.filterbranchid,
      'fromdate':this.fnFormatDatetime(this.filterfromdate),
      'todate':this.fnFormatDatetime(this.filtertodate), 
      'modifiedby': this.loginService.fnGetModUserId(),
    }
    this.appService.getApprovalsListview(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.approvalsColl = res.json().result;
            this.fnSetTable();
            this.fnCurrentRouteChange();

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnEditForm(deptid, formname) {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'id': deptid,
          'rtnform': 'Approvals'
        }
      }

      if (formname === 'Bonus') {
        this.router.navigate(['/AddBonus'], navigationExtras);
      }
      else if (formname === 'PayAdjustment') {
        this.router.navigate(['/AddPayadj'], navigationExtras);
      }
      else if (formname === 'Fine') {
        this.router.navigate(['/AddFine'], navigationExtras);
      }
      else if (formname === 'EmployeeDetailsChange') {
        this.router.navigate(['/AddEmpDetailsChange'], navigationExtras);
      }
      else if (formname === 'ShorttermPay') {
        this.router.navigate(['/AddShorttermPay'], navigationExtras);
      }
      else if (formname === 'Loan') {
        this.router.navigate(['/AddLoan'], navigationExtras);
      }
      else if (formname === 'PayAdvance') {
        this.router.navigate(['/AddPayadv'], navigationExtras);
      }
      else if (formname === 'Reimburse') {
        this.router.navigate(['/AddReimburse'], navigationExtras);
      }    
      else if (formname === 'Transfer') {
        this.router.navigate(['/AddTransfer'], navigationExtras);
      }
      else if (formname === 'OtherRequest') {
        this.router.navigate(['/AddOtherRequest'], navigationExtras);
      }     
      else if (formname === 'Leave') {
        this.router.navigate(['/AddLeave'], navigationExtras);
      }
      else if (formname === 'OverTime') {
        this.router.navigate(['/AddOvertime'], navigationExtras);
      }
     

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnShowFilterPopup() {

  const modalRef = this.productFindService.open(FilterpopupComponent, { size: <any>'l' });
  modalRef.componentInstance.formname = this.formname;

  modalRef.componentInstance.employeeid = Number(this.filteremployeeid);
  modalRef.componentInstance.branchid =  !this.filterbranchid ? null :Number(this.filterbranchid);

  modalRef.componentInstance.fromdate = this.filterfromdate;
  modalRef.componentInstance.todate = this.filtertodate;
 

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
    
    if (receivedEntry.status === 'DONE') {
     
      this.filteremployeeid = receivedEntry.employeeid;
      this.filteremployeename = receivedEntry.empname;
      this.filterbranchid = receivedEntry.branchid;
      this.filterbranchname = receivedEntry.branchname;
      this.filterfromdate=receivedEntry.fromdate;
      this.filtertodate=receivedEntry.todate;
    
      this.fngetApprovalsListview();
    }


  });
}
  
private fnExport() {

  const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
  modalRef.componentInstance.doctype = this.formname;
  modalRef.componentInstance.columnDefs = this.columnDefs;
  modalRef.componentInstance.contentColl = this.approvalsColl;
  modalRef.componentInstance.fnSetTable();
  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  
  });

} 

  fnSetTable() {
 
  }

  public fnSearchDatatable(value) {
 //   this.gridApi.setQuickFilter(value);
  }

  private fnFocusTableRow(index, status) {
    if (index > -1) {
      if (status === 'IN') {
        this.approvalsColl[index].hoverfocus = "IN"
      }
      else {
        this.approvalsColl[index].hoverfocus = ""
      }
    }
  }

  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//  
    }
    else {
      return '';
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }
  
    } else {
      return null
    }
  }  
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }










}
